module.exports = __webpack_public_path__ + "img/penn-engineering.27754230.jpg";